import { takeEvery, takeLeading, call, put } from 'redux-saga/effects';
import actionTypes from 'redux/actionTypes';
import {
	getPreviewSuccess,
	getPreviewFailure,
	getRowCountFailure,
	getRowCountSuccess,
	clearPreviewLoaded,
	saveDraftFailure,
	saveDraftSuccess,
	getPinnedAttributeSuccess,
	getPinnedAttributeFailure,
	savePinnedAttributeFailure,
	getVisualHierarchyDataFailure,
	getVisualHierarchyDataSuccess
} from './Preview.actions';
import { updateSavedReportsList } from '../Dashboard/Dashboard.actions';
import APIURLPATH from 'constants/apiconstants';
import { postData } from 'service/postData.service';
import { getData } from 'service/getData.service';
import { isCustomDataset } from 'helper/utils';
import { logUIError } from 'helper/logging';

export function* getPreviewSaga(request) {
	const {
		payload: { templateId }
	} = request;

	const URL = `${APIURLPATH.PREVIEW}?templateId=${templateId}`;
	let previewRes;
	try {
		previewRes = yield call(postData, URL, request.payload);

		if (previewRes?.statusCode >= 400) {
			throw new Error(previewRes?.statusCode);
		}

		yield put(getPreviewSuccess(previewRes?.json));
	} catch (error) {
		logUIError(
			request,
			actionTypes.GET_PREVIEW,
			URL,
			JSON.stringify(request.payload),
			previewRes ? JSON.stringify(previewRes) : 'No response'
		);
		yield put(getPreviewFailure(505));
	}
}

export function* clearPreviewSaga() {
	try {
		yield put(clearPreviewLoaded());
	} catch (error) {
		yield put(getPreviewFailure(505));
	}
}

export function* getRowCountSaga(request) {
	const {
		payload: { templateId }
	} = request;
	const datasetURL = `${APIURLPATH.ROW_COUNT}?templateId=${templateId}`;
	const customDatasetURL = `${APIURLPATH.CUSTOM_DATASET_ROW_COUNT}`;
	const URL = isCustomDataset(templateId) ? customDatasetURL : datasetURL;
	let rowCounRes;
	try {
		rowCounRes = yield call(postData, URL, request.payload);

		if (rowCounRes?.statusCode >= 400) {
			throw new Error(rowCounRes?.statusCode);
		}

		yield put(getRowCountSuccess(rowCounRes?.json));
	} catch (error) {
		logUIError(
			request,
			actionTypes.GET_ROW_COUNT,
			URL,
			JSON.stringify(request.payload),
			rowCounRes ? JSON.stringify(rowCounRes) : 'No response'
		);
		yield put(getRowCountFailure(505));
	}
}

export function* saveDraftSaga(request) {
	let response;
	try {
		response = yield call(postData, APIURLPATH.SAVE_DRAFT, request.payload);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}

		yield put(saveDraftSuccess(response?.json));
		yield put(updateSavedReportsList(response?.json));
	} catch (error) {
		logUIError(
			request,
			actionTypes.SAVE_DRAFT,
			APIURLPATH.SAVE_DRAFT,
			JSON.stringify(request.payload),
			response ? JSON.stringify(response) : 'No response'
		);
		yield put(saveDraftFailure(505));
	}
}

export function* getPinnedAttributeSaga({ payload }) {
	try {
		const API = `${APIURLPATH.PINNED_ATTRIBUTE}/${payload.templateId}`;
		const response = yield call(getData, API, payload);
		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const { pinnedAttributeList } = response?.json;
		yield put(
			getPinnedAttributeSuccess({
				templateId: payload.templateId,
				pinnedAttributeList
			})
		);
	} catch (error) {
		yield put(getPinnedAttributeFailure(505));
	}
}

export function* savePinnedAttributeSaga({ payload }) {
	try {
		const API = `${APIURLPATH.PINNED_ATTRIBUTE}`;
		const request = {
			companyName: payload?.companyName,
			requestBody: {
				templateId: payload?.templateId,
				templateName: payload?.templateName,
				pinnedAttributeList: payload?.pinnedAttributeList
			}
		};
		const response = yield call(postData, API, request);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const { pinnedAttributeList } = response?.json;
		// get or save pinnedAttribute action, both are doing same store update.
		yield put(
			getPinnedAttributeSuccess({
				pinnedAttributeList,
				templateId: payload.templateId
			})
		);
	} catch (error) {
		yield put(savePinnedAttributeFailure(505));
	}
}

export function* getVisualHierarchySaga(request) {
	try {
		const URL = `${APIURLPATH.VISUAL_HIERARCHY}`;
		const response = yield call(getData, URL, request.payload);
		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		yield put(getVisualHierarchyDataSuccess(response?.json));
	} catch (error) {
		yield put(getVisualHierarchyDataFailure([]));
	}
}

export function* previewSagaWatcher() {
	yield takeEvery(actionTypes.GET_PREVIEW, getPreviewSaga);
	yield takeEvery(actionTypes.GET_ROW_COUNT, getRowCountSaga);
	yield takeLeading(actionTypes.CLEAR_PREVIEWED_LOADED, clearPreviewSaga);
	yield takeLeading(actionTypes.SAVE_DRAFT, saveDraftSaga);
	yield takeLeading(actionTypes.GET_PINNED_ATTRIBUTE, getPinnedAttributeSaga);
	yield takeLeading(actionTypes.SAVE_PINNED_ATTRIBUTE, savePinnedAttributeSaga);
	yield takeEvery(actionTypes.GET_VISUAL_HIERARCHY, getVisualHierarchySaga);
}
